<div mat-dialog-title>
  <h3>{{ 'dialog.add_media_tags.title' | translate }}</h3>
</div>
<div mat-dialog-content>
  @if (!(loading$ | async)) {
    <app-doenkids-image [mediaItem]="{ uuid: data.mediaItem.uuid , description: '' }"></app-doenkids-image>
    @if ((notImplementedTags$ | async).length; as suggestionCount) {
      <div
        class="suggestions-wrapper"
      [innerHTML]="'dialog.add_media_tags.suggestions' | translate: {
        suggestionCount,
        suggestions: (notImplementedTags$ | async).join(', ')
      }"
      ></div>
    }
    <tag-input
      [formControl]="mediaItemTags"
      [onlyFromAutocomplete]="true"
      displayBy="name"
      identifyBy="id"
      [placeholder]="'activity.tags.placeholder' | translate"
      [secondaryPlaceholder]="'activity.tags.add' | translate"
      >
      <tag-input-dropdown [showDropdownIfEmpty]="true" [autocompleteItems]="( tags$ | async )" displayBy="name" identifyBy="id" [keepOpen]="false" [appendToBody]="false">
        <ng-template let-item="item" let-index="index">
          <div class="tag">
            @if (item.organization_unit_id === (currentOUId$ | async)) {
              <mat-icon>push_pin</mat-icon>
            }
            <span>
              {{ item.name }}
            </span>
          </div>
        </ng-template>
      </tag-input-dropdown>
    </tag-input>
  }
  @if ((loading$ | async)) {
    <mat-spinner class="spinner"></mat-spinner>
  }
</div>
<div mat-dialog-actions class="flex-row justify-end flex-1">
  <button mat-button color="primary" (click)="onClose()">
    {{ 'generic.close' | translate }}
  </button>
</div>
